import React from "react";
import s from "./FormErrorMessage.module.scss";
import { UseFormReturn, FieldName, FieldValues, FieldErrors } from "react-hook-form";
import { ErrorMessage, FieldValuesFromFieldErrors } from "@hookform/error-message";

function FormErrorMessage<T extends FieldValues>({form,name}: {form: UseFormReturn<T,any>, name: FieldName<FieldValuesFromFieldErrors<FieldErrors<T>>>}) {
    return <ErrorMessage errors={form.formState.errors} name={name} render={({ message }) => <p className={s.formError}>{message}</p>} />;
}

export default FormErrorMessage;